var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3675 20.9401L17 16.2628L21.6603 20.9401L23.2307 19.3526L18.5982 14.6752L23.2307 9.98717L21.6603 8.39962L17 13.077L12.3675 8.39962L10.7693 9.98717L15.4295 14.6752L10.7693 19.3526L12.3675 20.9401ZM8.79063 28.1666C8.07429 28.1666 7.46074 27.9112 6.94996 27.4005C6.43921 26.8897 6.18383 26.2761 6.18383 25.5598V3.39104H4.50004V1.29708H11.7521V0.0257072H22.2479V1.29708H29.5V3.39104H27.8162V25.5598C27.8162 26.2761 27.5608 26.8897 27.05 27.4005C26.5393 27.9112 25.9257 28.1666 25.2094 28.1666H8.79063ZM25.7222 3.39104H8.27779V25.5598C8.27779 25.688 8.33121 25.8055 8.43804 25.9124C8.54488 26.0192 8.6624 26.0727 8.79063 26.0727H25.2094C25.3376 26.0727 25.4551 26.0192 25.562 25.9124C25.6688 25.8055 25.7222 25.688 25.7222 25.5598V3.39104Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4",
    x: 0.500042,
    y: 0.0257072,
    width: 32.9999,
    height: 36.1409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.66800d8a1fb0d5bce2947d6a101814f2.svg";
export { ForwardRef as ReactComponent };